import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Layout, Input, Button, Typography } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import HeaderAITool from "../../../../assets/img/header.png";
import secondPicture from "../../../../assets/img/layer_.png";
import {
  decodePublicTranslationToken,
  isTokenExpired,
  PublicTranslationTokenPayload,
} from "./publicTranslation.utils";
import "./index.css";
import { useTranslation } from "react-i18next";

const { Content } = Layout;
const { TextArea } = Input;
const { Title } = Typography;

type PageState = "missing-token" | "invalid-token" | "expired" | "ready";

const PublicTranslation: React.FC = () => {
  const { t } = useTranslation("aiTools");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const decoded = useMemo<PublicTranslationTokenPayload | null>(() => {
    if (!token) return null;
    try {
      return decodePublicTranslationToken(token);
    } catch {
      return null;
    }
  }, [token]);

  const state: PageState = !token
    ? "missing-token"
    : !decoded
    ? "invalid-token"
    : isTokenExpired(decoded)
    ? "expired"
    : "ready";

  return (
    <div style={{ padding: "2rem" }}>
      <Content
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundColor: "white",
        }}
      >
        <div style={{ width: "100%" }}>
          <img
            src={HeaderAITool}
            alt="AI Tool Header"
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        <div className="translation-add-tool-content">
          {state !== "ready" ? (
            <div className="public-translation-state">
              <LinkOutlined style={{ fontSize: 40, color: "#ccc" }} />
              <Title level={5} className="title">
                {state === "missing-token" &&
                  t("publicTranslation.missingTokenTitle")}
                {state === "invalid-token" &&
                  t("publicTranslation.invalidTokenTitle")}
                {state === "expired" && t("publicTranslation.expiredTitle")}
              </Title>
              <p>
                {state === "missing-token" &&
                  t("publicTranslation.missingTokenDescription")}
                {state === "invalid-token" &&
                  t("publicTranslation.invalidTokenDescription")}
                {state === "expired" &&
                  t("publicTranslation.expiredDescription")}
              </p>
            </div>
          ) : (
            <>
              <div>
                <Title className="title" level={5} style={{ margin: "unset" }}>
                  {t("publicTranslation.title")}
                </Title>
                <p>{t("publicTranslation.description")}</p>
              </div>
              <div className="translate-part">
                <img
                  src={secondPicture}
                  alt="second picture"
                  className="secondImage"
                />
                <div style={{ width: "100%" }}>
                  <h2>{t("publicTranslation.surveyContent")}</h2>
                  <TextArea
                    rows={9}
                    value={JSON.stringify(decoded?.survey, null, 2)}
                    disabled
                    style={{ marginBottom: 24 }}
                  />

                  <h2>{t("publicTranslation.targetLanguage")}</h2>
                  <Input
                    value={decoded?.languageName}
                    disabled
                    style={{ marginBottom: 24 }}
                  />

                  <Button
                    className="public-translation-status-button"
                    disabled
                    block
                  >
                    {t("publicTranslation.statusButton")}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </Content>

      <div
        style={{
          textAlign: "center",
          marginTop: 24,
          color: "#bbb",
          fontSize: 12,
        }}
      >
        {t("publicTranslation.poweredBy")}{" "}
        <strong style={{ color: "#A072EB" }}>KAPinsights</strong>
      </div>
    </div>
  );
};

export default PublicTranslation;
